import { supabase } from '@/lib/supabase';
import {
  CreateDerivativeKpiInsert,
  CreateProjectKpiInsert,
  SubprojectBudgetUpdate,
} from '@/shared/types/api';

export const upsertProjectKpis = async (input: CreateProjectKpiInsert[]) => {
  const { error } = await supabase.from('project_kpis').upsert(input).select();

  if (error) {
    throw error;
  }
};

export const createClientSubprojectKpis = async (
  input: CreateProjectKpiInsert,
) => {
  if (!input.name || !input.type || !input.unit) {
    throw new Error('Name, type, and unit are required');
  }

  const { error } = await supabase.rpc('create_client_subproject_kpi', {
    p_project_id: input.project_id,
    p_name: input.name,
    p_tracking_type: input.type,
    p_unit: input.unit,
    p_max_value: input.max_value || undefined,
  });

  if (error) {
    throw error;
  }
};

export const upsertDerivativeKpis = async (
  input: CreateDerivativeKpiInsert[],
) => {
  const { error } = await supabase
    .from('derivative_kpis')
    .upsert(input)
    .select();

  if (error) {
    throw error;
  }
};

export const updateSubprojectKpiBudget = async (
  input: SubprojectBudgetUpdate & { id: string },
) => {
  const { error } = await supabase
    .from('subproject_view_budget')
    .update(input)
    .eq('id', input.id)
    .select();

  if (error) {
    throw error;
  }
};
